import { Box, Dialog, DialogContent, DialogTitle, styled, Typography } from "@material-ui/core";
import React from "react";

interface IPropRequestSubscribeGroup {
    groupName: string
    isOpen: boolean;
    planPrice: string;
    toggleModal: () => void;
    onRequestSubscribeGroup: () => Promise<void>;
}

export default function RequestSubscribeGroup(props: IPropRequestSubscribeGroup) {
    return <RequestSubscribeGroupStyled
        id="requestSubscribeGroupModal"
        open={props.isOpen}
        onClose={props.toggleModal}
        PaperProps={{
            style: {
                background: "#0B0B0B",
                border: "1px solid #35383F",
                padding: 20,
                borderRadius: 10,
                width: "calc(375px + 32px + 32px)",
                boxSizing: "border-box",
                gap: 24,
                alignItems: "center",
            }
        }}>
        <Box className="headerDialog">
            <DialogTitle>
                Request to join {props.groupName}
            </DialogTitle>
            <Box className="headerInformation">
                Admin will collect a commission fee from your subscriptions
            </Box>
        </Box>
        <DialogContent className="dialogContent">
            <Box className="containerPlanItem">
                <Box className="planHeader">
                    <Typography variant="h5">
                        Participant <Typography component="span">
                            (${props.planPrice} / Month)
                        </Typography>
                    </Typography>
                    <Box className="radioBtn">
                        <Box className="radioValue"></Box>
                    </Box>
                </Box>
                <Box className="planDescription">
                    <Typography variant="h5">
                        A participant observes the discussions without actively contributing. They may read messages but do not engage.
                    </Typography>
                </Box>
            </Box>
            <Box className="listAction">
                <Box className="buttonAction"
                    onClick={props.toggleModal}
                >
                    <Typography>
                        Cancel
                    </Typography>
                </Box>
                <Box
                    className={`buttonAction activeButton`}
                    onClick={props.onRequestSubscribeGroup}
                >
                    <Typography>
                        Request
                    </Typography>
                </Box>
            </Box>
        </DialogContent>
    </RequestSubscribeGroupStyled>
}

const RequestSubscribeGroupStyled = styled(Dialog)(() => ({
    "& .headerDialog": {
        position: "relative",
        width: "100%",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        gap: 5,
        "& .headerInformation": {
            textAlign: "center",
            fontFamily: "Manrope",
            fontWeight: 500,
            fontSize: 12,
            color: "#999"
        },
        "& .MuiDialogTitle-root": {
            padding: 0,
            paddingTop: 8,
            paddingBottom: 12,
            "& h2": {
                fontFamily: "Manrope",
                fontWeight: 800,
                fontSize: 24,
                color: "#FFF",
                lineHeight: "24px",
            }
        },
        "& .btnDeletePlan": {
            position: "absolute",
            top: 4,
            right: 0,
        },
    },
    "& .dialogContent": {
        display: "flex",
        flexDirection: "column",
        gap: 24,
        width: "100%",
        boxSizing: "border-box",
        padding: 0,
        "& .containerPlanItem": {
            padding: "10px 20px",
            borderRadius: 10,
            border: "1px solid #792FED",
            display: "flex",
            flexDirection: "column",
            gap: 10,
            "& .planHeader": {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                "& h5": {
                    fontFamily: "Manrope",
                    fontWeight: 800,
                    fontSize: 18,
                    color: "#FFF",
                    "& span": {
                        fontWeight: 700,
                        fontSize: 14,
                    }
                },
                "& .radioBtn": {
                    width: 20,
                    height: 20,
                    borderRadius: 16,
                    background: "linear-gradient(330.07deg, #3858E3 -51.03%, #BA05F7 138.78%)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    "& .radioValue": {
                        width: 8,
                        height: 8,
                        background: "#FFF",
                        borderRadius: 16,
                    }
                }
            },
            "& .planDescription": {
                "& h5": {
                    fontFamily: "Manrope",
                    fontWeight: 500,
                    fontSize: 10,
                    color: "#999",
                    marginBottom: 10,
                }
            }
        },
        "& .listAction": {
            display: "flex",
            paddingTop: 12,
            gap: 20,
            "& .buttonAction": {
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                border: "1px solid #FFF",
                borderRadius: 10,
                height: 48,
                boxSizing: "border-box",
                "& p": {
                    fontFamily: "Manrope",
                    color: "#FFF",
                    fontWeight: 700,
                    fontSize: 14,
                }
            },
            "& .buttonAction.activeButton": {
                borderColor: "transparent",
                background: "linear-gradient(330.07deg, #3858E3 -51.03%, #BA05F7 138.78%)",
            },
            "& .buttonAction.disabledButton": {
                opacity: 0.6,
                pointerEvents: "none",
                cursor: "not-allowed"
            },
        }
    }
}))